// Load Bootstrap JS
import bootstrap from 'bootstrap'

// Load Styles
import '../scss/main.scss';
import initEmailAddress from "./modules/init_email_address";
import initScrolledTextsAndImages from "./modules/init_scrolled_texts_and_images";
import initSimpleLightbox from "./modules/init_simple_lightbox";
import initFixedMenu from "./modules/init_fixed_menu";
import initVideoButton from "./modules/init_video_button";
import initReferenceGalleryWithPagination from "./modules/init_reference_gallery_with_pagination";
import initNewsListWithPagination from "./modules/init_news_list_with_pagination";
import initAnchorLinksInNav from "./modules/init_anchor-links-in-nav";
import initUgMenu from "./modules/init_ug_menu";
import initSwiper from "./modules/init_swiper";
import initSearchBar from "./modules/init_search_bar";

// Demo of using .env variables
// console.log(`Google Maps API Key: ${process.env.GOOGLE_MAPS_API_KEY}`);

window.addEventListener('load',()=>{
  initEmailAddress('.ks-email');
  initFixedMenu();
  initSearchBar();
  initScrolledTextsAndImages();
  initSimpleLightbox();
  initVideoButton();
  initReferenceGalleryWithPagination();
  initNewsListWithPagination();
  initAnchorLinksInNav();
  initUgMenu();
  initSwiper();
})
